import { styled } from "@linaria/react"
import { Link } from "@tanstack/react-router"

import { ellipsis } from "@/styles/mixins.ts"
import * as textStyles from "@/styles/textStyles.ts"

export const MessageAuthorName = styled(Link)`
  ${ellipsis};
  ${textStyles.smallerFontSize};

  /* Can't use font-size = line-height because it cuts off the descenders */
  margin: -1px 0;
  line-height: calc(var(--smaller-font-size) + 2px);

  align-self: flex-end;

  color: var(--badge-teal);
  font-weight: 600;

  &:hover {
    color: var(--badge-teal);
  }
`

export const MessageText = styled.div`
  ${textStyles.smallFontSize};
  ${textStyles.breakWord};

  color: var(--text-color);
`